/* eslint-disable @typescript-eslint/no-explicit-any */
import { Lang } from "@/i18n/settings";
import { getTokenFromFE } from "../token";
import { feApi } from "@/app/api/utils/api";
import { ApiResponse } from "@/types";
import { GalleryWinnerResponse } from "@/types/gallery";

interface GetGalleryParams {
  lang: Lang;
  pageNo?: number;
  pageSize?: number;
  year?: string;
  category?: string;
  type?: string;
  subCategory?: string;
}

export async function getGalleryPagePerformances({
  lang,
  pageNo,
  pageSize,
  year,
  category,
  type,
}: GetGalleryParams) {
  try {
    const token = await getTokenFromFE();

    const queryParams = new URLSearchParams();

    if (pageNo) queryParams.append("pageNo", pageNo.toString());
    if (pageSize) queryParams.append("pageSize", pageSize.toString());
    if (year) queryParams.append("year", year);
    if (category) queryParams.append("category", category);
    if (type) queryParams.append("type", type);

    const res = await feApi
      .auth(`Bearer ${token}`)
      .options({ next: { revalidate: 60 } })
      .url("/v1")
      .get(`/${lang}/gallery/performances?${queryParams.toString()}`);

    return res as ApiResponse<any>;
  } catch (error) {
    console.error(error);

    return null;
  }
}

export async function getGalleryPageWinners({
  lang,
  pageNo,
  pageSize,
  year,
  category,
  subCategory,
}: GetGalleryParams) {
  try {
    const token = await getTokenFromFE();

    const queryParams = new URLSearchParams();

    if (pageNo) queryParams.append("pageNo", pageNo.toString());
    if (pageSize) queryParams.append("pageSize", pageSize.toString());
    if (year) queryParams.append("year", year);
    if (category) queryParams.append("category", category);
    if (subCategory) queryParams.append("subcategory", subCategory);

    const res = await feApi
      .auth(`Bearer ${token}`)
      .options({ next: { revalidate: 60 } })
      .url("/v1")
      .get(`/${lang}/gallery/winners?${queryParams.toString()}`);

    return res as ApiResponse<GalleryWinnerResponse["data"]>;
  } catch (error) {
    console.error(error);

    return null;
  }
}

export async function getGalleryPageCarpets({
  lang,
  pageNo,
  pageSize,
  year,
  type,
}: GetGalleryParams) {
  try {
    const token = await getTokenFromFE();

    const queryParams = new URLSearchParams();

    if (pageNo) queryParams.append("pageNo", pageNo.toString());
    if (pageSize) queryParams.append("pageSize", pageSize.toString());
    if (year) queryParams.append("year", year);
    if (type) queryParams.append("type", type);

    const res = await feApi
      .auth(`Bearer ${token}`)
      .options({ next: { revalidate: 60 } })
      .url("/v1")
      .get(`/${lang}/gallery/carpets?${queryParams.toString()}`);

    return res as ApiResponse<any>;
  } catch (error) {
    console.error(error);

    return null;
  }
}
